"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gtmCustomForm = exports.GTMCustomForm = void 0;
const app_1 = require("app");
const FormikConfig_1 = require("../FormikFields/FormikConfig");
const constants_1 = require("./constants");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
class GTMCustomForm extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.umbraco-forms-form';
        this.spinnerImage = MosaicIcon_1.MosaicIconFactory.createIcon('loader-circle', 'button-spinner hidden mr-2 spin animate-spin');
        this.preventFormSubmission = false;
        this.formValidationPassed = false;
        this.processFormSubmission = () => {
            var _a;
            const submitButton = this.currentlySubmittedForm.querySelector('.submit-button');
            const processingButtonLabel = app_1.AttrService.data(document.querySelector('.umbraco-forms-navigation'), 'processing-button-label');
            (_a = document.querySelector('.button-spinner')) === null || _a === void 0 ? void 0 : _a.classList.remove('hidden');
            submitButton.innerText = processingButtonLabel;
            submitButton.disabled = true;
            this.replaceSpecificSymbolsInDropdown(this.currentlySubmittedForm);
            this.formValidationPassed = false;
            app_1.GTM.customForm($(this.currentlySubmittedForm));
        };
        this.onRecaptchaError = () => {
            if (this.formValidationPassed) {
                this.processFormSubmission();
            }
        };
    }
    BeforeInit() {
        this.el.forEach(el => {
            this.CurrentFormWrapper(el);
        });
        document.body.addEventListener('recaptchaChange', this.processFormSubmission);
        document.body.addEventListener('recaptchaError', this.onRecaptchaError);
    }
    CurrentFormWrapper(_el) {
        const form = _el.querySelector('form');
        const submitButton = form.querySelector('.submit-button');
        const bypassRecaptchaKey = app_1.AttrService.data(document.querySelector('.umbraco-forms-navigation'), 'bypass-recaptcha-key');
        // Set the form name for Google Tag Manager
        app_1.GTM.setCustomFormName($(form));
        $(form).submit((event, formStatus) => {
            const embargoCountryErrors = form.querySelectorAll('.countries-validation-error');
            const stateValidationError = form.querySelectorAll('.form-state-error-message');
            if ((embargoCountryErrors && embargoCountryErrors.length > 0) ||
                (stateValidationError && stateValidationError.length > 0)) {
                event.preventDefault();
                return;
            }
            else {
                submitButton.prepend(this.spinnerImage);
            }
            const isProcessed = formStatus === constants_1.formStatuses.processed;
            if (isProcessed) {
                return true;
            }
            event.preventDefault();
            if (!this.preventFormSubmission) {
                setTimeout(() => {
                    const formErrors = form.querySelectorAll('.field-validation-error');
                    const recaptchaBypass = (0, FormikConfig_1.recaptchaKeyGuard)(bypassRecaptchaKey);
                    if (formErrors && formErrors.length > 0) {
                        const stateSelectDropdownWrapper = form.querySelector('.countrystateprovince');
                        const stateSelectValidationClass = stateSelectDropdownWrapper.querySelectorAll('.field-validation-error');
                        if (stateSelectValidationClass && stateSelectValidationClass.length > 0) {
                            stateSelectDropdownWrapper
                                .querySelectorAll('select')[0]
                                .classList.add('input-validation-error');
                        }
                        this.preventFormSubmission = false;
                        return;
                    }
                    this.formValidationPassed = true;
                    this.currentlySubmittedForm = form;
                    recaptchaBypass ? this.processFormSubmission() : this.performReCaptchaCheck();
                });
                this.preventFormSubmission = true;
            }
        });
    }
    performReCaptchaCheck() {
        const recaptcha = window['grecaptcha'];
        if (recaptcha && recaptcha.execute) {
            recaptcha.execute();
        }
        else {
            this.processFormSubmission();
        }
    }
    //delete symbol \ (used for jQuery validation) in selected dropdown for email template
    replaceSpecificSymbolsInDropdown(form) {
        $(form)
            .find('.country-state-dropdown select')
            .each(function () {
            const dropdownValue = $(this).val();
            if (dropdownValue) {
                const newVal = dropdownValue.replace(/\\/g, '');
                $(this).find('option:selected').val(newVal);
                $(this).val(newVal);
            }
        });
    }
}
exports.GTMCustomForm = GTMCustomForm;
exports.gtmCustomForm = new GTMCustomForm();
